export default {
	"autoLineStrategy": {
		"cantEmpty": "can not be empty ",
		"algoModel": "algorithm model",
		"name": "tactics name",
		"remark": "illustrate",
		"tabHeader": "tactics information",
		"useTimeWindow": "whether to consider time windows",
		"multTemp": "whether multi-thermospheric transport",
		"noSystemLog": "do not look at the data of system operation",
		"dialogTitle": "add an automatic routing strategy",
		"carSetting": "vehicle settings",
		"fullLoadUpper": "vehicle full load rate upper limit",
		"fullLoadLower": "vehicle full load rate lower limit",
		"lightRatio": "volume/weight ratio (m3/ton)",
		"maxTransDuration": "the longest transport operation time",
		"lineSetting": "line settings",
		"relativeDistanceWeight": "relative distance weight",
		"relativeDistance": "relative distance base value",
		"deliveryPositionUpper": "delivery string point limit",
		"incideMaxDistanceRatio": "piggyback maximum distance ratio",
		"regionUpper": "maximum number of regions",
		"planBeginExcuteTime": "scheduled execution start time",
		"wharfWorkSpeed": "terminal throughput speed",
		"defaultUnloadSpeed": "default unloading speed",
		"defaultJoinTime": "default handover time",
		"recSendTitle": "shipping and receipt settings",
		"onlyEnableStrategySelectTips": "Only policies in the enabled state can be selected"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/autoLineStrategy/autoLineStrategy.js